import { Injectable } from '@angular/core';
import { SymbolType } from '../../../../../domain/symbol.domain';
import { AccountHelper, TradingAccount } from '../../../../../domain/account.domain';

import { OrderItem, OrderStatusType, PriceType, Strategy } from '../../../domain';
import { OrderFormParameters, OrderStateParameters } from '../../domain/order-entry.domain';
import { FormService } from '../../domain/services.domain';

// Base service for order creation
@Injectable()
export abstract class CreateOrderFormService<T> implements FormService<T> {
  protected temp: T = {} as T; // TODO refactor methods into returning values instead of setting props values

  protected filterParameters(parameters: OrderStateParameters, account: TradingAccount): OrderStateParameters {
    const isShortMarginAccount = this.isShortMarginAccount(account);
    if (isShortMarginAccount && parameters.securityType === SymbolType.EQUITY) {
      if (parameters.action === 'buy') { // TODO: inconsistent use of enum
        return Object.assign({}, parameters, {
          action: 'buy_to_cover'
        });
      } else if (parameters.action === 'sell') {
        return Object.assign({}, parameters, {
          action: 'short_sell'
        });
      }
    }
    return parameters;
  }

  protected isShortMarginAccount(account: Pick<TradingAccount, 'type'>): boolean {
    return AccountHelper.isMarginShort(account);
  }

  // reason: because the server doesnt send the flag for order type, we have to deduct from shape
  processOpenTriggeredOrder(orderItem: OrderItem): void {
    if (orderItem.orderStatus === OrderStatusType.OPEN_TRIGGERED && 'trailingStopTerms' in orderItem.extendedTerms) {
      if (orderItem.extendedTerms.trailingStopTerms.limitDelta === undefined) {
        orderItem.extendedTerms.orderType = PriceType.TRAILING_STOP_MARKET;
      } else {
        orderItem.extendedTerms.orderType = PriceType.TRAILING_STOP_LIMIT;
      }
    }
  }

  /**
   * Initialize object that represent state of UI across multiple steps
   */
  abstract initializeViewModel(selectedAccount?: TradingAccount,
    orderFormParameters?: OrderFormParameters, strategy?: Strategy, index?: number): T;
}

